import React from "react";
import Modal from "../shared/Modal";

const PrivacyPolicy = ({ onAccept, isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onAccept={onAccept}
      title="Privacy Policies"
      acceptText="Accept & Continue"
      closeText="Close"
      maxWidth="1000px"
    >
      <div className="privacy-policy-content">
        <p className="last-updated">Last updated on 1/12/2021</p>

        <div className="policy-section">
          <h3>Privacy Policy of INVAI LTD</h3>
          <p>
            <strong>SWIPEY</strong> (the <strong>"APP"</strong>) is owned and
            operated by <strong>INVAI LTD</strong>, duly incorporated in the
            Republic of Cyprus under incorporation number HE458964, having its
            address at Agiou Alexiou street 1, 1st Floor, 2054, Nicosia,
            Republic of Cyprus.
          </p>
          <p>
            <strong>SWIPEY</strong> is an online chat application that uses
            artificial intelligence algorithms to generate virtual and fictional
            characters (the "AI Companions"). The APP also generates images and
            messages, so that you can chat with the AI Companions. Parts of the
            Services offered by the APP may require you to create a user
            account. For purposes of this Privacy Policy, "you" and "your" mean
            you as the user of the APP.
          </p>
        </div>

        <div className="policy-section">
          <h3>GDPR</h3>
          <p>
            If you are a resident of the European Union, you are protected by
            and enjoy additional rights under the European Union's General Data
            Protection Regulation 2016/679, also known as GDPR.
          </p>
        </div>

        <div className="policy-section">
          <h3>1. Definitions</h3>
          <p>
            As we are committed to respecting your privacy, such Services will
            always be provided with your consent.
          </p>
          <p>
            In this document, we provide clear information on how your data is
            processed when you visit the Website and when you use our Services.
          </p>
          <p>At any time, please refer to the following definitions:</p>
          <p>
            <strong>"Content"</strong> means the information that you will
            provide us with so that we can register you as a User and the
            information you will upload on our Platform, such information shall
            include your Personal Data and the discussions with the AI
            Companions;
          </p>
          <p>
            <strong>"Consent"</strong> means any freely given, specific,
            informed, and unambiguous indication of your wishes by which you, by
            a statement or by a clear affirmative action, signify agreement to
            the Processing of Personal Data relating to you;
          </p>
          <p>
            <strong>"Performance of our Services"</strong> means the actions
            necessary for us to provide our Services;
          </p>
          <p>
            <strong>"Personal Data"</strong> means any information relating to
            you, as an identified person, directly or indirectly, such as your
            name, address, marital status, date of birth, gender, office
            location, position, company name, spoken languages, photos, your
            identification number, your location data, or factors specific to
            your physical, physiological, genetic, mental, economic, cultural,
            or social identity, your networks and connections made available to
            us, or obtained on your behalf and any personal information you
            would provide us with;
          </p>
          <p>
            <strong>"Platform"</strong> means the APP.
          </p>
          <p>
            <strong>"Processing"</strong> means any operation or set of
            operations which is performed on Personal Data or on sets of
            Personal Data, whether or not by automated means, such as
            collection, recording, organization, structuring, storage,
            adaptation or alteration, retrieval, consultation, use, disclosure
            by transmission, dissemination or otherwise making available,
            alignment or combination, restriction, erasure or destruction;
          </p>
          <p>
            <strong>"Services"</strong> means all the steps for enabling you to
            chat with the AI Companions;
          </p>
          <p>
            <strong>"Subscription"</strong> means an arrangement between INVAI
            LTD and you to enable you to benefit from and/or use the Services;
          </p>
          <p>
            <strong>"User"</strong>, <strong>"you"</strong> and{" "}
            <strong>"your"</strong> collectively mean a person or company that
            has visited or is using the APP and/or the Services;
          </p>
          <p>
            <strong>"Visitor"</strong> means anyone who is browsing the Website
            without a valid Subscription;
          </p>
          <p>
            <strong>"Website"</strong> means{" "}
            <a>https://swipey.ai/</a>.
          </p>
        </div>

        <div className="policy-section">
          <h3>2. Purpose of Personal Data Processing</h3>
          <h4>When visiting the Website</h4>
          <p>
            When you visit the Website, we will collect information for the
            following purposes:
          </p>
          <ul>
            <li>Analyzing and understanding your behavior on the Website;</li>
            <li>Performing our Services;</li>
            <li>Making improvements to the Website and Services;</li>
            <li>
              Enabling us to enhance, customize, or modify our communications;
            </li>
            <li>Improving data security;</li>
            <li>Determining whether marketing campaigns are effective.</li>
          </ul>

          <h4>When registering and using our Services</h4>
          <p>
            After a FREE test of a few messages, you will be asked to register,
            so we can identify you. At this stage, we receive and store any
            information you enter on the Website or that you provide us with in
            any other way. The types of Personal Data collected may include (but
            are not limited to) your name, date of birth, usage information
            regarding your use of our Services, and browser information.
          </p>
          <p>
            The Personal Data you provide is used for purposes such as allowing
            you to set up a User account and profile that can be used to
            interact with the AI Companions. We may also draw upon this Personal
            Data to adapt the Services to your needs and to develop new tools.
          </p>
        </div>

        <div className="policy-section">
          <h3>3. Personal Data collection</h3>
          <h4>3.1 Personal Data collection for Visitors</h4>
          <p>
            The Website can be visited anonymously. The Website may process
            anonymous metadata through cookies such as the URL of the requested
            file, the amount of data transferred, the date and time of the
            request from the User, Internet browser information, operating
            system type, the IP address of the used device, the Internet service
            provider, reference links such as user clicks on certain links. This
            metadata cannot be used by the Website to obtain personally
            identifiable information. This information is only used for general
            purposes, such as technical improvements, and statistical and
            marketing analysis.
          </p>

          <h4>3.2 Personal Data collection for Users</h4>
          <p>
            We use different methods to collect Personal Data from and about
            you, including through:
          </p>
          <ul>
            <li>
              From the information you provide to us when you register for
              Subscription;
            </li>
            <li>
              From the Content you provide to us via your personal account on
              the Website;
            </li>
            <li>
              When you communicate with us in writing, by telephone, fax,
              website registration, email or other forms of electronic
              communication. In this respect, we may monitor, record and store
              any such communication;
            </li>
            <li>
              Automated technologies or interactions. As you interact with the
              AI Companions, we may automatically collect technical data about
              your equipment, browsing actions, and patterns. Our moderation
              team checks that you are in compliance with the law and we collect
              this Personal Data by using cookies, server logs, and other
              similar technologies. We may also receive technical data about you
              if you visit other websites employing our cookies;
            </li>
            <li>
              Third parties or publicly available sources. We may receive
              Personal Data about you from various third parties and public
              sources as set out below:
              <ul>
                <li>Analytics providers such as Google Analytics;</li>
                <li>Advertising networks/agencies; and</li>
                <li>Search information providers.</li>
              </ul>
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h3>4. Marketing</h3>
          <p>
            We may send you marketing about services we provide which may be of
            interest to you, as well as other information in the form of alerts,
            newsletters, and invitations to events or functions which we believe
            might be of interest to you or to update you with information (such
            as legal or commercial news) which we believe may be relevant to
            you. We may communicate this to you in a number of ways including by
            post, telephone, email, or other digital channels.
          </p>
        </div>

        <div className="policy-section">
          <h3>5. Third Party Marketing</h3>
          <p>
            We will get your express opt-in consent before we share your
            Personal Data with any company outside SWIPEY for marketing
            purposes.
          </p>
          <p>
            You can ask us or third parties to stop sending you marketing
            messages at any time by logging into the Website, or third-party
            websites and checking or unchecking relevant boxes to adjust your
            marketing preferences or by following the opt-out links on any
            marketing message sent to you.
          </p>
        </div>

        <div className="policy-section">
          <h3>6. Cookies</h3>
          <p>
            You can set your browser to refuse all or some browser cookies or to
            alert you when websites set or access cookies. If you disable or
            refuse cookies, please note that some parts of the Website may
            become inaccessible or not function properly.
          </p>
        </div>

        <div className="policy-section">
          <h3>7. Change of purpose</h3>
          <p>
            We will only use your Personal Data for the purposes for which we
            collected it unless we reasonably consider that we need to use it
            for another reason and that reason is compatible with the original
            purpose. If you wish to get an explanation as to how the processing
            for the new purpose is compatible with the original purpose, please
            contact us. If we need to use your Personal Data for an unrelated
            purpose, we will notify you and we will explain the legal basis
            which allows us to do so. Please note that we may process your
            Personal Data without your knowledge or consent, in compliance with
            the above rules, where this is required or permitted by law.
          </p>
        </div>

        <div className="policy-section">
          <h3>8. Sharing your personal information</h3>
          <p>
            <strong>SWIPEY</strong> may share your information with:
          </p>
          <ul>
            <li>Service providers we work with to deliver the Services;</li>
            <li>
              Our professional advisers where it is necessary for us to obtain
              their advice or assistance including lawyers, accountants, IT or
              public relations advisers;
            </li>
            <li>
              Legal and regulatory authorities, as required by applicable laws
              and regulations; and
            </li>
            <li>Our employees.</li>
          </ul>
          <p>
            We will not disclose, sell, trade, or otherwise transfer your
            personal information to any third parties without your consent or
            unless otherwise stated in this Privacy Policy.
          </p>
        </div>

        <div className="policy-section">
          <h3>9. Sensitive Information</h3>
          <p>
            We will never ask you to provide us with Personal Data revealing
            racial or ethnic origin, political opinions, religious or
            philosophical beliefs, or trade union membership, and genetic data,
            biometric data for the purpose of uniquely identifying a natural
            person, or data concerning health. If you decide to provide us with
            such sensitive information, you understand that you willingly
            disclose such sensitive information.
          </p>
        </div>

        <div className="policy-section">
          <h3>10. Controller</h3>
          <p>
            This Privacy Policy is issued on behalf of{" "}
            <strong>INVAI LTD</strong> so when we mention <strong>"we"</strong>{" "}
            or <strong>"us"</strong>, in this Privacy Policy, we are referring
            to <strong>INVAI LTD</strong>.
          </p>
          <p>
            We have appointed a Controller, within our team, who is responsible
            for overseeing questions in relation to this Privacy Policy. If you
            have any questions about this Privacy Policy, including any requests
            to exercise your legal rights, please contact the Controller using
            the details set out below.
          </p>
          <p>Contact details:</p>
          <p>
            Email: <a href="mailto:admin@invai.tech">Admin@invai.tech</a>
            <br />
            Post: Agiou Alexiou street 1, 1st Floor, 2054, Nicosia, Republic of
            Cyprus
          </p>
        </div>

        <div className="policy-section">
          <h3>11. Request to access your Personal Data</h3>
          <p>
            At any time, you have the right to access your Personal Data. This
            enables you to receive a copy of the Personal Data we hold about you
            and to check that we are lawfully Processing it.
          </p>
        </div>

        <div className="policy-section">
          <h3>12. Period</h3>
          <p>
            We retain your personal information for as long as your account is
            in existence or necessary to fulfill the purposes for which we
            collect it or as needed to provide you with the Services, except if
            required otherwise by law. However, when you terminate your account,
            we will still retain your personal information for a period of time.
            Usually, we will store your personal information for a period of 6
            (six) years after you cease being a User of our Services, beginning
            at the date your account is closed.
          </p>
          <p>
            Retention periods may be changed from time to time based on business
            or regulatory requirements.
          </p>
        </div>

        <div className="policy-section">
          <h3>13. Personal information of minors</h3>
          <p>
            <strong>INVAI LTD</strong> does not provide Services and collects
            personal information from anyone under 18 years of age or equivalent
            minimum age depending on jurisdiction. Our Services are intended for
            use only by adults who are 18 years of age and over. If we learn
            that we have been misled by an individual under 18, or equivalent
            minimum age depending on jurisdiction, we will take steps to delete
            the information as soon as possible and block this user.
          </p>
        </div>

        <div className="policy-section">
          <h3>14. Third-party links</h3>
          <p>
            The Website may include links to third-party websites, plug-ins, and
            applications. Clicking on those links or enabling those connections
            may allow third parties to collect or share data about you. We do
            not control these third-party websites and are not responsible for
            their privacy statements. We encourage you to read the Privacy
            Policy of every website that can be accessed through the Website.
          </p>
        </div>

        <div className="policy-section">
          <h3>15. Merge of Company</h3>
          <p>
            If <strong>INVAI Ltd</strong> merges with, or is acquired by,
            another company or organization, or sells all or a portion of its
            assets, your personal information may be disclosed to our advisers
            and any prospective purchaser or any prospective purchaser's
            adviser, and may be among the assets transferred. However, personal
            information will always remain subject to this Privacy Policy.
          </p>
        </div>

        <div className="policy-section">
          <h3>16. Right to rectification</h3>
          <p>
            You have the right to obtain from the Controller without undue delay
            the rectification of inaccurate Personal Data concerning you.
          </p>
          <p>
            This enables you to have any incomplete or inaccurate data we hold
            about you corrected, though we may need to verify the accuracy of
            the new data you provide to us.
          </p>
        </div>

        <div className="policy-section">
          <h3>
            17. Right to request restriction of processing of your Personal Data
          </h3>
          <p>
            This enables you to ask our Controller to suspend the processing of
            your Personal Data in the following scenarios: (a) if you want us to
            establish the Personal Data's accuracy; (b) where our Processing of
            the Personal Data is unlawful and you do not want us to erase it and
            request us to suspend the Processing instead; (c) where you need us
            to hold the Data to establish, exercise or defend legal claims; or
            (d) you have objected to our Processing of your Personal Data and we
            need to verify whether we have overriding legitimate grounds to use
            it.
          </p>
        </div>

        <div className="policy-section">
          <h3>18. Withdrawal of Consent</h3>
          <p>
            We are committed to making it as easy to withdraw as to give
            consent.
          </p>
          <p>
            You have the right to withdraw your Consent at any time. The
            withdrawal of Consent shall not affect the lawfulness of Processing
            of your Personal Data based on consent before its withdrawal.
          </p>
          <p>
            If you withdraw your Consent, we will not be able to provide any
            more of our Services to you and we will take reasonable steps,
            taking into account available technology and means to delete your
            user account in a timely manner. We will also delete the Personal
            Data we have collected on you for internal use.
          </p>
        </div>

        <div className="policy-section">
          <h3>19. Right to be forgotten</h3>
          <p>
            You have the right to obtain from the Controller the erasure of
            Personal Data concerning you without undue delay and the Controller
            undertakes to erase Personal Data without undue delay.
          </p>
          <p>
            This enables you to ask us to delete or remove Personal Data where
            there is no good reason for us continuing to Process it. You also
            have the right to ask us to delete or remove your Personal Data
            where you have successfully exercised your right to object to
            processing, where we may have processed your information unlawfully,
            or where we are required to erase your Personal Data to comply with
            local law. Note, however, that we may not always be able to comply
            with your request for erasure for specific legal reasons which will
            be notified to you, if applicable, at the time of your request.
          </p>
        </div>

        <div className="policy-section">
          <h3>20. Time limit to respond</h3>
          <p>
            We try to respond to all legitimate requests within one month.
            Occasionally it may take us longer than a month if your request is
            particularly complex or you have made several requests. In this
            case, we will notify you and keep you updated.
          </p>
        </div>

        <div className="policy-section">
          <h3>21. Data Security</h3>
          <p>
            We have put in place appropriate security measures to prevent your
            Personal Data from being accidentally lost, used, or accessed in an
            unauthorized way, altered, or disclosed.
          </p>
          <p>
            We have put in place procedures to deal with any suspected Personal
            Data breach and will notify you and any applicable regulator of a
            breach where we are legally required to do so.
          </p>
        </div>

        <div className="policy-section">
          <h3>
            22. Changes to the Privacy Policy and your duty to inform us of
            changes
          </h3>
          <p>
            We may revise this Privacy Policy from time to time. Therefore, we
            may undertake a few changes to it. This version of the Privacy
            Policy will govern our use of your information. If we make any
            material changes in the way we use your Personal Data, we shall
            notify you by posting and sending you an email in order to obtain
            your approval. By continuing to access or use the Services after
            those changes become effective, you agree to be bound by the revised
            Privacy Policy.
          </p>
          <p>
            Please keep a copy of this document at all times and feel FREE to
            ask us any questions or address any concerns you may have regarding
            our Privacy Policy.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default PrivacyPolicy;
